
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/society/signup",
      function () {
        return require("private-next-pages/society/signup/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/society/signup"])
      });
    }
  